import React from "react";

import Link from "core-web/components/Link";
import colors from "theme/config/colors";
import styled from "theme/libs/styled";
import styleObjectToProps from "core-web/utils/styleObjectToProps";
import ChevronIcon from "./icons/ChevronIcon";
import { useTranslation } from "react-i18next";
import ScrollableBox from "core-web/components/ScrollableBox";
import BleedWrapper from "./wrappers/BleedWrapper";
import { checkForLocalePrefix } from "core-web/utils/checkForLocalePrefix";

const MaskedScrollableBox = styled(ScrollableBox)`
    --slider-padding: 20px;

    ${({ theme }) => theme.above.tabletLg} {
        --slider-padding: 48px;
    }

    padding-inline: var(--slider-padding);
    mask-image: linear-gradient(
        90deg,
        transparent,
        #fff var(--slider-padding),
        #fff calc(100% - var(--slider-padding)),
        transparent 100%
    );
`;

const StyledList = styled("ol")`
    display: flex;
    gap: 6px;

    > li {
        white-space: nowrap;

        :last-of-type {
            padding-right: 20px;

            ${({ theme }) => theme.above.tabletLg} {
                padding-right: 48px;
            }
        }
    }
`;

const Title = styled("span")``;

const mapBreadcrumbsLinks = (items) =>
    items.map((item, index) => {
        const isLast = index === items.length - 1;
        const color = isLast ? colors.black_90 : colors.black_70;

        const link = isLast ? undefined : item.permalink || item.url;
        const localPrefix = checkForLocalePrefix(link);

        return (
            <li key={item.title}>
                <Link volatile key={item.title} to={link?.replace(`${localPrefix}/`, "")}>
                    <Title color={color}>{item.title}</Title>
                    {index !== items.length - 1 && (
                        <ChevronIcon height="0.8em" width="auto" ml="6px" color={color} aria-hidden />
                    )}
                </Link>
            </li>
        );
    });

const Breadcrumbs = ({ breadcrumbs = [], isPDP = false }) => {
    const { t } = useTranslation();
    return (
        <BleedWrapper>
            <MaskedScrollableBox
                as="nav"
                scrollDirection="horizontal"
                aria-label={t("aria_labels.breadcrumbs")}
                py={isPDP ? "16px" : ["8px", null, null, null, "16px"]}
                {...styleObjectToProps("Myriad Pro/12-100")}
            >
                <StyledList>{mapBreadcrumbsLinks(breadcrumbs)}</StyledList>
            </MaskedScrollableBox>
        </BleedWrapper>
    );
};

export default Breadcrumbs;
